import { TAG_STATUS, TagGroupItemV2 } from './common';
import { TagsFindResponseBodyTagsDto } from '../api/tags';
import { GetTagListRequest } from '../../lib/api/tag/type';
import { SearchOption } from '../common/table';

export class TagItemV2 {
  id: number;
  name: string;
  status: TAG_STATUS;
  url: string;
  tagGroupList: TagGroupItemV2[];
  createDate: string;

  constructor(item: TagsFindResponseBodyTagsDto) {
    this.id = item.id;
    this.name = item.name;
    this.status = item.status;
    this.url = item.tagAttachments[0]?.url;
    this.tagGroupList = item.tagGroups;
    this.createDate = item.createDate;
  }
}

export class TagListRequestOptionV2 implements GetTagListRequest {
  id?: number | null;
  name?: string;
  status?: 'active' | 'inactive' | 'confirmReady' | 'delete';
  page?: number;
  pageSize?: number;
  sort?: string;

  constructor(option: SearchOption<Partial<Pick<TagItemV2, 'id' | 'name' | 'status'>>>) {
    this.id = option.id ? option.id : null;
    this.name = option.name;
    this.page = option.page;
    this.pageSize = option.pageSize;
    this.sort = option.sort?.join(',');
    this.status = option.status;
  }
}
